import React from 'react'
import styled from 'styled-components'
import LazyImage from '../../../components/LazyImage'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { useCongress } from '../../../congress/hooks'

export default function SponsorCard ({ imageURL, name, id, clickable }) {
  const { congress, generateLink } = useCongress()

  return (
   <Container whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.9 }}>
     <StyledLink to={clickable ? generateLink(`/sponsors/${id}`) : undefined}>
       <ImageContainer>
         <Image src={imageURL} width="100%" height="100%"/>
       </ImageContainer>
       <Name color={congress.PrimaryColor}>{name}</Name>
     </StyledLink>
   </Container>
  )
}

const Container = styled(motion.div)`
  display: inline-block;
  background: #FFF;
  box-shadow: 0 3px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
  width: 100%;
  margin: 1.2rem 0;
  height: 19.5rem;
`

const StyledLink = styled(Link)`
  display: flex;
  padding: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none !important;
`

const ImageContainer = styled.div`
  width: 100%;
  padding-bottom: 50%;
  position:relative;
`

const Image = styled(LazyImage)`
  position: absolute;
  border-radius: 10px;
  overflow: hidden;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

const Name = styled.p`
  font-size: 1.5rem;
  font-weight: 800;
  margin-top: 1rem;
  color: ${props => props.color};
`